import { createAsyncThunk } from "@reduxjs/toolkit";
import { addAgesTreatedApiUrl } from "../ApiUrls/AddAgesTreatedApiUrl";
import axios from "axios";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { v4 as uuidV4 } from "uuid";

export const addAgesTreatedAPI = createAsyncThunk(
  "addAgesTreatedAPI",
  async (payload) => {
    try {
      const response = await axios.post(addAgesTreatedApiUrl, payload, {
        headers: {
          "X-Request-Id": uuidV4(),
        },
      });
      return response.data;
    } catch (error) {
      console.log("Error : ", error);
    }
  }
);

export const fetchagesTreadedTedails = createAsyncThunk(
  "fetchagesTreadedTedails",
  async ({ practiceId, providerId }) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/providers/${providerId}?view=extended`
    );
    return result;
  }
);

export const fetchUpdateagesTreated = createAsyncThunk(
  "fetchUpdateagesTreated",
  async ({ practiceId, providerId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/providers/${providerId}?view=brief`,
      data
    );
    return result;
  }
);
